import React, { useLayoutEffect, useState } from 'react'
import useViewport from "hooks/useViewport";

export function useAutoFocusOnDesktop() {
    const [hasFocused, setHasFocused] = useState(false)
    // ssr needs to be disabled for auto focus based on viewport to work
    const noSsr = true
    const { isMobileOrSmaller } = useViewport(noSsr)

    useLayoutEffect(() => {
        setHasFocused(true)
    }, [])

    return { autoFocusInputRef: input => input && !isMobileOrSmaller && !hasFocused && input.focus() }
}